import { render, staticRenderFns } from "./xiaoduishouzhibaobiao.vue?vue&type=template&id=44771256&scoped=true&"
import script from "./xiaoduishouzhibaobiao.vue?vue&type=script&lang=js&"
export * from "./xiaoduishouzhibaobiao.vue?vue&type=script&lang=js&"
import style0 from "./xiaoduishouzhibaobiao.vue?vue&type=style&index=0&id=44771256&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44771256",
  null
  
)

export default component.exports